import Swal from "sweetalert2";
import api from "../../../utilidades/interceptor";
import axios from "axios";

const urlApi = process.env.REACT_APP_API_KEY;

const mostrarErrorGenerico = (contexto, error) => {
    console.error(`[integracion] Error en ${contexto}:`, error);
};

export const getModules = async () => {
    try {
        const { data } = await api.get(`${urlApi}/administrator/permisions/getModules`);
        return data;
    } catch (error) {
        mostrarErrorGenerico('getModules', error);
        return [];
    }
};

export const getModulesById = async (id_user) => {
    try {
        const { data } = await api.get(`${urlApi}/administrator/permisions/getModulesById`, {
            params: { id_user },
        });
        return data;
    } catch (error) {
        mostrarErrorGenerico('getModulesById', error);
        return {};
    }
};

export const getPermisosTipo = async () => {
    try {
        const { data } = await api.get(`${urlApi}/administrator/permisions/getPermisosTipo`);
        return data;
    } catch (error) {
        mostrarErrorGenerico('getPermisosTipo', error);
        return [];
    }
};

export const getPermisosUsuario = async (id_user) => {
    try {
        const { data } = await api.get(`${urlApi}/administrator/permisions/getPermisosUsuario`, {
            params: { id_user },
        });
        return data;
    } catch (error) {
        mostrarErrorGenerico('getPermisosUsuario', error);
        return {};
    }
};

export const updatePermisions = async (id_user, permisions) => {
    Swal.fire({
        title: 'Cargando...',
        text: 'Actualizando datos...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => Swal.showLoading(),
    });

    try {
        const { data } = await api.patch(`${urlApi}/administrator/permisions`, {
            id_user,
            permisions: JSON.stringify(permisions),
        });

        Swal.close();
        Swal.fire({ title: 'Actualizado con éxito', icon: 'success' });

        return data;
    } catch (error) {
        mostrarErrorGenerico('updatePermisions', error);
        Swal.close();
        Swal.fire({ title: 'Error al actualizar datos', icon: 'error' });
        throw error;
    }
};

export const updatePermisosUsuario = async (id_user, permisos) => {
    try {
        const { data } = await api.patch(`${urlApi}/administrator/permisosUsuario`, {
            id_user,
            permisos: JSON.stringify(permisos),
        });
        return data;
    } catch (error) {
        mostrarErrorGenerico('updatePermisosUsuario', error);
        throw error;
    }
};

export const getCollaborators = async () => {
    try {
        const { data } = await api.get(`${urlApi}/administrator/collaborators`);
        return data;
    } catch (error) {
        mostrarErrorGenerico('getCollaborators', error);
        return [];
    }
};

export const updateJsonMenu = async (stringJson) => {
    try {
        const { data } = await axios.post(`${urlApi}/menu/updateJsonMenu`, { stringJson });
        return data;
    } catch (error) {
        mostrarErrorGenerico('updateJsonMenu', error);
        throw error;
    }
};
